import React from 'react';
import { materials, assets } from '../data/mock';
import useReveal from '../hooks/useReveal';

const Reveal = ({ children, delay = 0, className = '' }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
      className={`reveal ${visible ? 'in' : ''} ${className}`}
    >
      {children}
    </div>
  );
};

const Craftsmanship = () => {
  return (
    <section className="bg-[#EDE3CF] py-16 md:py-20 grain relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="text-center mb-16 md:mb-20">
            <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-4">— The craft</p>
            <h2
              className="text-5xl md:text-7xl text-[#33200F] leading-[1.02] mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Built the way <span className="italic text-[#5B3A24]">it used to be</span>.
            </h2>
            <p className="max-w-2xl mx-auto text-[#5B3A24] text-[15px] leading-[1.85]">
              {assets.craftBlurb || 'Solid timber. Hand-pulled bouclé. Joints that survive moves and decades.'}
            </p>
          </div>
        </Reveal>
        <StaggeredGrid />
      </div>
    </section>
  );
};

const StaggeredGrid = () => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal-stagger ${visible ? 'in' : ''} grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14`}
    >
      {materials.map((m) => (
        <div key={m.n} className="group">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#E3D5B8]">
            <img
              src={m.image}
              alt={m.name}
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover image-zoom"
            />
            <span className="absolute top-5 left-5 text-[#F5EDDD] text-[11px] tracking-[0.32em] uppercase">
              {m.n}
            </span>
          </div>
          <div className="mt-6">
            <h3
              className="text-2xl md:text-3xl text-[#33200F] mb-3 leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {m.name}
            </h3>
            <p className="text-[#5B3A24] text-[14px] leading-[1.85]">{m.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Craftsmanship;
